export interface ToolItem {
  id: string;
  href: string;
  icon: string;
  color: string;
  bg: string;
  title: string;
  description: string;

  // Optional UI elements
  badge?: string;
  badgeBg?: string;
  badgeColor?: string;

  // Metadata
  privacyNote?: string;
  isClientSide?: boolean;
}

export const tools: ToolItem[] = [
  {
    id: 'merge-pdf',
    href: '/merge-pdf',
    icon: 'DocumentPlusIcon',
    color: '#E8445A',
    bg: '#FFF0F2',
    title: 'Merge PDF',
    description:
      'Combine multiple PDFs into one file. 100% private. All processing happens in your browser.',
    badge: 'Popular',
    badgeBg: '#FFF0F2',
    badgeColor: '#E8445A',
    privacyNote: 'Client-side · No upload',
    isClientSide: true,
  },
  {
    id: 'split-pdf',
    href: '/split-pdf',
    icon: 'ScissorsIcon',
    color: '#3B82F6',
    bg: '#EFF6FF',
    title: 'Split PDF',
    description:
      'Extract specific pages or split a PDF into multiple files. Your file never leaves your device.',
    badge: '',
    badgeBg: '',
    badgeColor: '',
    privacyNote: 'Client-side · No upload',
    isClientSide: true,
  },
  {
    id: 'sign-pdf',
    href: '/sign-pdf',
    icon: 'PencilSquareIcon',
    color: '#6366F1',
    bg: '#EEF2FF',
    title: 'Sign PDF',
    description:
      'Draw, upload, or type a signature and place it on any page of your PDF. Secure processing with instant file deletion.',
    badge: 'New',
    badgeBg: '#EEF2FF',
    badgeColor: '#6366F1',
    privacyNote: 'Server-side · Auto-deleted',
    isClientSide: false,
  },
  {
    id: 'compress-pdf',
    href: '/compress-pdf',
    icon: 'ArchiveBoxIcon',
    color: '#10B981',
    bg: '#ECFDF5',
    title: 'Compress PDF',
    description:
      'Reduce file size while keeping quality. Secure server processing with instant deletion after download.',
    badge: 'Fast',
    badgeBg: '#ECFDF5',
    badgeColor: '#10B981',
    privacyNote: 'Server-side · Auto-deleted',
    isClientSide: false,
  },
  {
    id: 'rotate-pdf',
    href: '/rotate-pdf',
    icon: 'ArrowPathIcon',
    color: '#F59E0B',
    bg: '#FFFBEB',
    title: 'Rotate PDF',
    description:
      'Fix page orientation permanently. Rotate individual pages or all at once, right in your browser.',
    badge: '',
    badgeBg: '',
    badgeColor: '',
    privacyNote: 'Client-side · No upload',
    isClientSide: true,
  },
  {
    id: 'lock-pdf',
    href: '/lock-pdf',
    icon: 'LockClosedIcon',
    color: '#7C5CBF',
    bg: '#F3EEFF',
    title: 'Lock PDF',
    description:
      'Add password protection with 256-bit AES encryption. Live strength meter. No copies stored.',
    badge: 'Secure',
    badgeBg: '#F3EEFF',
    badgeColor: '#7C5CBF',
    privacyNote: 'Server-side · Auto-deleted',
    isClientSide: false,
  },
  {
    id: 'unlock-pdf',
    href: '/unlock-pdf',
    icon: 'LockOpenIcon',
    color: '#0EA5B0',
    bg: '#EDFCFD',
    title: 'Unlock PDF',
    description:
      'Remove a password from PDFs you own. Processed in memory and wiped the moment your download is ready.',
    badge: '',
    badgeBg: '',
    badgeColor: '',
    privacyNote: 'Server-side · Auto-deleted',
    isClientSide: false,
  },
  {
    id: 'organize-pdf',
    href: '/organize-pdf',
    icon: 'Squares2X2Icon',
    color: '#8B5CF6',
    bg: '#F5F3FF',
    title: 'Organize PDF',
    description:
      'Reorder, rotate, or delete pages with drag and drop. Preview any page in full-screen before saving.',
    badge: '',
    badgeBg: '',
    badgeColor: '',
    privacyNote: 'Client-side · No upload',
    isClientSide: true,
  },
  {
    id: 'remove-pages',
    href: '/remove-pages',
    icon: 'TrashIcon',
    color: '#EF4444',
    bg: '#FEF2F2',
    title: 'Remove PDF Pages',
    description:
      'Mark pages for deletion, preview them in full-screen, and download your updated PDF. 100% private.',
    badge: '',
    badgeBg: '',
    badgeColor: '',
    privacyNote: 'Client-side · No upload',
    isClientSide: true,
  },
];

export const navLinks = [
  { label: 'All Tools', href: '/tools' },
  { label: 'Blog', href: '/blog' },
  { label: 'About', href: '/about' },
  { label: 'Contact', href: '/contact' },
];
